const FixedBlockProduct = () => {
  const fixedBlockProduct = document.querySelector(".fixed-block-product");
  const priceServicesWrapper = document.querySelector(".product-main__price-services-btns-wrapper");

  if (fixedBlockProduct && priceServicesWrapper) {
    const options = {
      root: null,
      rootMargin: "0px 0px 0px 0px",
      threshold: 0.1 
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          fixedBlockProduct.classList.remove("visible");
        } else {
          fixedBlockProduct.classList.add("visible");
        }
      });
    }, options);

    observer.observe(priceServicesWrapper);
  }
};

export default FixedBlockProduct;
